import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import style from './styles/style.module.css';

class DLCheckbox extends PureComponent {
    constructor(props) {
        super(props);

        this.isControlled = this.props.checked !== undefined;
        this.state = {
            isChecked: !!this.props.checked,
        };
    }
    changeHandler = ( e ) => {
        var newState = e.target.checked;
        var value = e.target.value;
        if( !this.isControlled ) {
            this.setState( { isChecked: newState } );
        }
        this.props.onChange( e, newState, value );
    }



    render() {
        const { label } = this.props;
        var isChecked = this.state.isChecked;
        if( this.isControlled ) {
            isChecked = !!this.props.checked;
        }

        var inlineStyle = { ...this.props.style };
        if( this.props.size ) {
            inlineStyle.width = inlineStyle.height = this.props.size + 'px';
        }

        var inputProps = {
            onChange: this.changeHandler,
            value: this.props.value,
            name: this.props.name,
            checked: isChecked,
        };

        return (
            <label className={ `${ this.props.className } ${ style.checkbox }` }
            style={ inlineStyle } onClick={ this.props.onClick }
            data-disabled={ this.props.disabled }
            data-checked={ isChecked }>
                <div className={ style.box }></div>
                { label &&
                    <div className={ style.label } style={ this.props.labelStyle }>{ label }</div>
                }
                <input type='checkbox' { ...inputProps } disabled={ this.props.disabled } />
            </label>
        );
    }
}
DLCheckbox.propTypes = {
    checked: PropTypes.bool,
    className: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string,
    label: PropTypes.string,
    style: PropTypes.object,
};
DLCheckbox.defaultProps = {
    className: '',
    onChange: () => {},
    onClick: () => {},
};

export default DLCheckbox;
